export const formatName = (
  firstName: string | null,
  lastName: string | null
) => {
  if (!firstName && !lastName) {
    return '-'
  }
  return `${firstName ?? ''} ${lastName ?? ''}`
}
